export default __webpack_public_path__ + "static/media/ind9.d1bb598c.jpg";